// src/redux/actions/salesActions.js
import {
    UPDATE_CUSTOMER_DEMO_SUCCESS,
    UPDATE_CUSTOMER_DEMO_REQUEST,
    UPDATE_CUSTOMER_DEMO_FAILURE,

} from '../../../../Constants/actionTypes';
import { updateDemoSessionStatus } from '../../../../Constants/apiService'


// Fetch Sales Request Action
export const updateDemoSessionRequest = () => ({
    type: UPDATE_CUSTOMER_DEMO_REQUEST,
});

// Fetch Sales Success Action
export const updateDemoSessionSuccess = (salesData) => ({
    type: UPDATE_CUSTOMER_DEMO_SUCCESS,
    payload: salesData,

});

// Fetch Sales Failure Action
export const updateDemoSessionFailure = (error) => ({
    type: UPDATE_CUSTOMER_DEMO_FAILURE,
    payload: error,
});




// Thunk Action Creator for Fetching Sales
export const updateCustomerDemoSessionAct = (params) => {
   console.log(params)
    return async (dispatch, getState) => {
        dispatch(updateDemoSessionRequest());

        const state = getState();
        const accessToken = state.auth.accessToken;


        try {
            const data = await updateDemoSessionStatus(accessToken,params);


            if (data?.success) {
                dispatch(updateDemoSessionSuccess(data));
                return true; // Indicate success
            } else {
                throw new Error('Unexpected API response format');
            }
           
            // dispatch(updateDemoSessionSuccess(data));
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(updateDemoSessionFailure(errorMessage));
        }
    };
};

